import React, { useState, useEffect } from 'react'; 
import { formatDateToYYYY_MM_DD } from "../../Utils/DateUtils";
import Abstract_Trans_District from './Abstract_Trans_District'


const AbstractTransReport = ({ heading }) => {
    
     const [renderContent, setRenderContent] = useState(null);   
     const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); 
        const day = String(today.getDate()).padStart(2, "0"); 
        return `${year}-${month}-${day}`;
      };
      getTodayDate();
      const [selectedDate, setSelectedDate] = useState(getTodayDate());


    const handleChange = (event) => {
        setSelectedDate(event.target.value);   
      };
    

const handleSubmit = () => {
    const trans_date = document.getElementById('trans_date').value;

    if (!trans_date) {
        alert('Please select Date');
    } else {
        const parts = trans_date.split("-"); 
        const yy = parts[0];       
        const mm = parts[1];
        const dd = parts[2];
        const formatted_date = `${yy}-${mm}-${dd}`;

        setRenderContent(null);

        setTimeout(() => {
            setRenderContent(
                <Abstract_Trans_District date={formatted_date} />
            );
        }, 0);
    }
};


    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="30%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={8}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Date</td>
                                    <td><input type="date"   name="trans_date"  id="trans_date" 
                                         value = {selectedDate} onChange={handleChange} /> </td>
                                </tr>
                                <tr>
                                    <td colSpan={8} align="center">
                                    <button onClick={handleSubmit} className="button button2"                                     >
                                    Submit
                                    </button>
                                    <button className="button button2">
                                        Back
                                    </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                    <div id="detailsER">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default AbstractTransReport;
